import { API_URL } from '../../../app-config/constants';
import type { AutomationDto, CreateAutomationDto } from '../../react/features/Automations/types';
import { get, post, remove } from '../request';

const BASE_URL = `${API_URL}/automations`;

getById.operation = 'READ';
export function getById(id: string): Promise<AutomationDto> {
    return get<AutomationDto>(`${BASE_URL}/${id}`);
}

list.operation = 'READ';
export function list(params: { employeeCreated: boolean; type?: string }): Promise<AutomationDto[]> {
    return get<AutomationDto[]>(`${BASE_URL}`, { getData: params });
}

create.operation = 'CREATE';
create.invalidates = ['list'];
export function create(automation: CreateAutomationDto): Promise<AutomationDto> {
    return post<AutomationDto>(`${BASE_URL}`, { postData: automation });
}

edit.operation = 'COMMAND';
export function edit(id: string, automation: CreateAutomationDto): Promise<AutomationDto> {
    return post<AutomationDto>(`${BASE_URL}/${id}`, { postData: automation });
}

deleteAutomation.operation = 'DELETE';
deleteAutomation.invalidates = ['list'];
export function deleteAutomation(id: string): Promise<never> {
    return remove(`${BASE_URL}/${id}`);
}
